<template>
  <ul>
    <menu-options-item close label="Abrir" @click="$emit('abrir')" icon="folder-open" />
  </ul>
</template>

<script>
import MenuOptionsItem from '../../../../layout/context-menu/context-window-options-item'
export default {
  name: 'cliente-list-menu',
  props: ['cliente'],
  components: {MenuOptionsItem}
}
</script>
